import React from "react";
import { Search, Bell, Command } from "lucide-react";

/**
 * ToolbarSticky — top bar signature WYVIO.
 * Glass, backdrop-blur, pas de vert sur le logo.
 * Le seul vert est la pastille de notification (accent rare).
 */
export function ToolbarSticky({ agency = "Stéphane · Deluxe Motors", testid }) {
  return (
    <header
      data-testid={testid}
      className="wyvio-toolbar-glass shadow-wyvio-toolbar sticky top-0 z-40 flex h-[68px] items-center justify-between px-10"
      style={{ borderBottom: "1px solid rgba(21,21,21,0.05)" }}
    >
      {/* Logo signature — point gris (le lime devient rare) */}
      <div className="flex items-center gap-3">
        <span className="text-[22px] font-medium tracking-[-0.03em] text-[#151515]">
          wyvio
        </span>
        <span
          aria-hidden
          className="mb-2 -ml-3 inline-block h-1.5 w-1.5 rounded-full"
          style={{ background: "#151515" }}
        />
      </div>

      {/* Recherche pill */}
      <div className="mx-8 flex-1 max-w-[420px]">
        <label
          htmlFor="wyvio-search"
          className="group flex h-10 items-center gap-3 rounded-full bg-[#EEEEE8] pl-4 pr-3 transition-[background-color,box-shadow] duration-200 focus-within:bg-white focus-within:shadow-[0_0_0_2px_#151515,0_0_0_4px_rgba(255,255,255,1)]"
        >
          <Search className="h-4 w-4 text-[#8A8A80]" strokeWidth={2} />
          <input
            id="wyvio-search"
            type="text"
            data-testid="toolbar-search"
            placeholder="Rechercher un dossier, un client, une plaque…"
            className="flex-1 bg-transparent text-[13.5px] text-[#151515] placeholder:text-[#8A8A80] focus:outline-none"
          />
          <kbd className="hidden items-center gap-0.5 rounded-md bg-white px-1.5 py-0.5 text-[10px] font-medium text-[#8A8A80] shadow-[0_0_0_1px_#E8E8E2] sm:inline-flex">
            <Command className="h-2.5 w-2.5" /> K
          </kbd>
        </label>
      </div>

      {/* Right cluster */}
      <div className="flex items-center gap-2">
        <button
          data-testid="toolbar-notifications"
          className="relative flex h-10 w-10 items-center justify-center rounded-full text-[#6B6B67] transition-colors hover:bg-[#EEEEE8] hover:text-[#151515]"
          aria-label="Notifications"
        >
          <Bell className="h-[18px] w-[18px]" strokeWidth={2} />
          <span
            aria-hidden
            className="absolute right-2.5 top-2.5 h-1.5 w-1.5 rounded-full"
            style={{
              background: "#C8FF2F",
              boxShadow: "0 0 0 2px #F8F8F5",
            }}
          />
        </button>
        <div className="ml-2 flex items-center gap-3 rounded-full bg-white px-2 py-1.5 shadow-[0_0_0_1px_#E8E8E2]">
          <span
            className="flex h-7 w-7 items-center justify-center rounded-full bg-[#151515] text-[11px] font-medium text-white"
            aria-hidden
          >
            S
          </span>
          <span className="pr-2 text-[12.5px] font-normal text-[#151515]">
            {agency}
          </span>
        </div>
      </div>
    </header>
  );
}
